export enum UserTypeEnum {
  Normal = 0,
  Master = 1,
  Manager = 2,
}
